
export default function Privacy() {
  const styles = {
    content: {
      maxWidth: 800,
      margin: '0 auto',
    },
    section: {
      background: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(10px)',
      borderRadius: 16,
      padding: 32,
      marginBottom: 24,
      border: '1px solid rgba(255, 255, 255, 0.2)',
    },
    title: {
      fontSize: 32,
      fontWeight: 800,
      marginBottom: 8,
    },
    lastUpdated: {
      fontSize: 14,
      opacity: 0.8,
      marginBottom: 32,
    },
    subtitle: {
      fontSize: 20,
      fontWeight: 700,
      marginTop: 24,
      marginBottom: 12,
    },
    text: {
      fontSize: 16,
      lineHeight: 1.8,
      opacity: 0.95,
      marginBottom: 16,
    },
  };

  return (
    <div style={styles.content}>
      <h1 style={styles.title}>Privacy Policy</h1>
      <p style={styles.lastUpdated}>Last Updated: January 8, 2026</p>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>Introduction</h2>
        <p style={styles.text}>
          Inbox Sentinel ("we", "our", or "us") is committed to protecting your privacy.
          This Privacy Policy explains how we handle information when you use our spam filtering
          service for CRM platforms.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>Information We Access</h2>
        <p style={styles.text}>
          To provide spam filtering services, Inbox Sentinel accesses:
        </p>
        <ul style={{ paddingLeft: 24, lineHeight: 1.8 }}>
          <li>Inbound email conversations in your inbox</li>
          <li>Contact information for spam sender identification</li>
          <li>Location information to scope filtering to your account</li>
        </ul>
        <p style={styles.text}>
          We only access data necessary to identify and remove spam messages.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>How We Use Information</h2>
        <p style={styles.text}>
          Information accessed by Inbox Sentinel is used solely to:
        </p>
        <ul style={{ paddingLeft: 24, lineHeight: 1.8 }}>
          <li>Analyze inbound emails for spam characteristics</li>
          <li>Remove identified spam messages from your inbox</li>
          <li>Delete or flag spam-related contacts as requested</li>
          <li>Provide and improve our spam filtering service</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>Data Storage and Retention</h2>
        <p style={styles.text}>
          <strong>Inbox Sentinel is stateless by default.</strong> We do not store customer email
          content, conversation data, or contact information on external servers.
        </p>
        <p style={styles.text}>
          All spam detection processing happens in real-time when emails arrive. Once processed,
          the data is discarded.
        </p>
        <p style={styles.text}>
          We only store OAuth tokens necessary to access your account, which are:
        </p>
        <ul style={{ paddingLeft: 24, lineHeight: 1.8 }}>
          <li>Encrypted in our database</li>
          <li>Used only for authenticated API requests</li>
          <li>Deleted when you uninstall the application</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>Data Sharing</h2>
        <p style={styles.text}>
          We do not sell, rent, or share your data with third parties. Your email content and
          contact information remain within the platform ecosystem and are never transmitted
          to external services except as required to provide the filtering service.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>Security</h2>
        <p style={styles.text}>
          We implement industry-standard security measures to protect access to your account:
        </p>
        <ul style={{ paddingLeft: 24, lineHeight: 1.8 }}>
          <li>OAuth 2.0 authentication</li>
          <li>Encrypted token storage</li>
          <li>Secure HTTPS connections</li>
          <li>Minimal permission scope (conversations and contacts only)</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>Your Rights</h2>
        <p style={styles.text}>
          You have the right to:
        </p>
        <ul style={{ paddingLeft: 24, lineHeight: 1.8 }}>
          <li>Uninstall Inbox Sentinel at any time from the platform settings</li>
          <li>Request deletion of stored OAuth tokens by contacting support</li>
          <li>Contact us with privacy concerns or questions</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>Changes to This Policy</h2>
        <p style={styles.text}>
          We may update this Privacy Policy from time to time. We will notify users of material
          changes by updating the "Last Updated" date and, when appropriate, through the
          Marketplace notification system.
        </p>
      </div>

      <div style={styles.section}>
        <h2 style={styles.subtitle}>Contact Us</h2>
        <p style={styles.text}>
          If you have questions about this Privacy Policy, please contact us:
        </p>
        <p style={styles.text}>
          Email: <a href="mailto:inbox.sentinel@hello.miltonecom.com" style={{ color: '#fff' }}>inbox.sentinel@hello.miltonecom.com</a><br />
          Phone: +1 (866) 259-3033
        </p>
      </div>
    </div>
  );
}
